<template>
  <div style="background: #EFF5FF;position: relative;padding-top: 1px">
    <!-- 头部内容 -->
    <div class="header_bg"></div>
    <div class="header">
      <div class="flex-0">
        <div class="head">
          <expert-upload-view ref="avatarRef" :avatar-size="75" avatar-height="90px" avatar-flag
                              config-key="expert.apply.peoplePicture" :refer-id="expertInfo.id"/>
        </div>
      </div>
      <div class="w-100">
        <p class="text1">欢迎您，{{ expertInfo.expertName }}专家！</p>
        <p class="text2">
          <a-icon type="mobile"/>
          {{ expertInfo.mobilePhone }}<a @click="editPhone(expertInfo)">更换手机</a></p>
        <div class="text3" v-if="ExpertState.STATE.LEAVE_DOING === expertInfo.state ">
          <img :src="$_c + 'img/mobile/icon1.svg'"/>
          <span>{{ expertInfo.extras.stateText }}</span>
        </div>
      </div>
      <img class="right_icon" :src="$_c + 'img/mobile/icon2.png'"/>
    </div>

    <!-- 主要内容区域 -->
    <main class="p-16-24 main">
      <!-- 通知区域 -->
      <section class="mb-5" v-if="contentTypeValue === '1'">
        <div class="m_zj_t2">
          <div class="title">
            <div class="text1">
              <img :src="$_c + 'img/mobile/icon3.svg'"/>
              您有<span>{{ notices.length }}</span>项活动待参加
            </div>
            <div class="text2" @click="openLeaveDescription()">
              <a-icon type="question-circle"/>
              请假规定
            </div>
          </div>
          <a-card :body-style="{display: 'flex',alignItems: 'center',justifyContent: 'center',height: '200px'}"
                  v-if="notices.length === 0">
            <a-empty
                description="您没有待参加的活动">
            </a-empty>
          </a-card>
          <div v-for="(notice, index) in notices" :key="index" class="mb-5">
            <a-card>
              <div class="row">
                <div class="text1">通知日期：</div>
                <div class="text2">{{ notice.addDate | dayjs('YYYY-MM-DD') }}</div>
              </div>
              <div class="row">
                <div class="text1">集合时间：</div>
                <div class="text2">{{ notice.setOfTime }}</div>
              </div>
              <div class="row">
                <div class="text1">集合地点：</div>
                <div class="text2">{{ notice.setOfAddress }}</div>
              </div>
              <div class="row">
                <div class="text1">活动类型：</div>
                <div class="text2">
                  <dict-text dictKey="BID_ZJSZYT" :value="notice.applyType"/>
                </div>
              </div>
              <div class="row">
                <div class="text1">预计时长</div>
                <div class="text2">{{ notice.reviewDuration }}</div>
              </div>
              <div class="row">
                <div class="text1">需携带资料</div>
                <div class="text2">{{ notice.information }}</div>
              </div>
              <div style="padding: 0 12px 12px 0;text-align: right">
                <a-button type="primary"
                          icon="clock-circle"
                          size="large"
                          v-if="ExtractExpertFlagEnum.ATTEND[0] === notice.expertFlag"
                          @click="showLeaveModal(notice)">
                  请假
                </a-button>
              </div>
            </a-card>
          </div>
        </div>

      </section>
      <!-- 休假申请区域 -->
      <section v-if="contentTypeValue === '2'">
        <div class="m_zj_t3">
          <div class="title">
            <div class="text1">我的休假记录</div>
            <div class="text2">
              <a-button
                  type="primary"
                  @click="addLeaveRecord()">新增休假
              </a-button>
            </div>
          </div>
          <a-card :body-style="{display: 'flex',alignItems: 'center',justifyContent: 'center',height: '200px'}"
                  v-if="expertLeaveRecordList.length === 0">
            <a-empty
                description="无休假计划">
            </a-empty>
          </a-card>
          <div v-for="record in expertLeaveRecordList"
               :key="record.id"
               class="mb-5">
            <a-card>
              <span slot="title">填报日期：{{ record.addTime | dateFormat }}</span>
              <div slot="extra">
                <a-tag color="green"
                       v-if="isEfficacious(record.leaveStartTime, record.leaveEndTime, record.state)">有效
                </a-tag>
                <a-tag v-else>已结束</a-tag>
              </div>
              <div>
                <p>休假开始日期：{{ record.leaveStartTime | dateFormat }}</p>
                <p>休假结束日期：{{ formattedLeaveEndTime(record.leaveEndTime) }}</p>
                <p>休假原因：{{ record.leaveReason }}</p>
              </div>
              <template slot="actions"
                        v-if="record.state==='0'">
                <a-button type="danger"
                          :loading="saveLoading"
                          @click="onSubmitTerminationLeave(record)">终止休假
                </a-button>
              </template>
            </a-card>
          </div>

        </div>
      </section>
    </main>
    <div class="m_zj_t1">
      <p class="text1">请惠存我司自动语音通知电话：</p>
      <p class="text2" style="font-size: 20px">{{ calledShowNumber | calledNumberFormat }}</p>
      <p class="text1">我司人工咨询电话：</p>
      <p class="text2" style="font-size: 20px">{{ this.consult_telePhone || '' }}</p>
    </div>
    <!-- 底部导航 -->
    <div style="height: 100px"></div>
    <div class="wein-map-footer">
      <a-row>
        <a-col :class="'wein-map-footer-item border-right' + (contentTypeValue === '1' ? ' active' : '')"
               :span="12"
               @click="switchMenu('1')">
          <a-icon type="bell" theme="filled"/>
          <div>活动通知</div>
        </a-col>
        <a-col :class="'wein-map-footer-item' + (contentTypeValue === '2' ? ' active' : '')"
               :span="12"
               @click="switchMenu('2')">
          <a-icon type="clock-circle" theme="filled"/>
          <div>休假设置</div>
        </a-col>
      </a-row>
    </div>

    <!-- 请假弹窗 -->
    <a-modal v-model="leaveApplyForVisible"
             title="请假"
             class="selfModal"
             :dialog-style="{ top: '20px' }"
             width="100%"
             :confirmLoading="confirmLoading"
             okText="确认请假"
             @ok="submitLeLeaveApplyFor"
             @cancel="handleCancel">
      <a-form-model ref="form"
                    layout="vertical"
                    :model="leaveApplyForData"
                    :rules="rules">
        <a-form-model-item label="请假原因"
                           prop="leaveReason">
          <a-textarea v-model="leaveApplyForData.leaveReason"
                      :auto-size="{ minRows: 4, maxRows: 5 }"
                      placeholder="请输入请假原因"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!-- 休假记录弹窗 -->
    <a-modal title="新增休假"
             :dialog-style="{top:'20px'}"
             width="100%"
             class="selfModal"
             okText="提交"
             :confirmLoading="saveLoading"
             v-model="seetingVisible"
             @ok="onLeaveRecordSubmit">
      <a-form-model layout="vertical"
                    ref="expertLeaveForm"
                    :rules="leaveRecordRules"
                    :model="expertLeaveForm">
        <a-form-model-item label="休假类型">
          <a-checkbox v-model="leaveRecordType"
                      @change="onChangeLeaveRecordType">
            长期休假
          </a-checkbox>
        </a-form-model-item>
        <a-form-model-item label="休假开始时间"
                           prop="leaveStartTime">
          <a-date-picker class="w-100"
                         v-model="expertLeaveForm.leaveStartTime"
                         :disabled-date="disabledStartDate"
                         :format="dateFormatStr"
                         :value-format="dateFormatStr"
                         placeholder="开始时间"/>
        </a-form-model-item>
        <a-form-model-item label="休假结束时间"
                           prop="leaveEndTime"
                           :rules="[{ required: !leaveRecordType, message: '请输入休假结束时间', trigger: 'change' }]">
          <a-date-picker class="w-100"
                         v-if="!leaveRecordType"
                         v-model="expertLeaveForm.leaveEndTime"
                         :disabled-date="disabledEndDate"
                         :format="dateFormatStr"
                         :value-format="dateFormatStr"
                         placeholder="结束时间"/>
          <span class="color-red"
                v-else>长期</span>
        </a-form-model-item>
        <a-form-model-item label="休假原因"
                           prop="leaveReason">
          <a-textarea v-model="expertLeaveForm.leaveReason"
                      :auto-size="{ minRows: 4, maxRows: 5 }"
                      placeholder="请输入休假原因"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <!--    修改手机号-->
    <edit-mobile-phone-modal ref="editMobilePhone"
                             @success="loadData()"/>
  </div>
</template>

<script>
import { ExtractExpertFlagEnum } from '@/epp/expertmain/selectexpertapply/utils/ExpertApplyUtils'
import {
  ExpertLeaveBySelf,
  GetExpertByUserId,
  GetExpertLeaveRecordByExpertId,
  QueryExpertReviewActiveNoticeListByUserIdList,
  SetLeaveRecordTime,
  SetTerminationLeave
} from '@/epp/expertmain/expertInfo/api/ExpertInfoApi'
import { ExpertState, IsLeaveRecord } from '@/epp/expertmain/expertInfo/utils/ExpertInfoUtil'
import { QueryMetadataList } from '@/api/componentsApi'
import moment from 'moment'
import ExpertLeaveApplyForModal from '@/epp/expertmain/expertInfo/common/ExpertLeaveApplyForModal'
import DictText from '@/components/dict/DictText'
import ExpertLeaveRecord from '@/epp/expertmain/expertInfo/ExpertLeaveRecord'
import { COMPANY_WEBSITE, CONSULT_TELE_PHONE } from '@/store/mutation-types'
import ExpertUploadView from '@/components/selector/ExpertUploadView.vue'
import EditMobilePhoneModal from '@/views/dashboard/EditMobilePhoneModal.vue'

export default {
  name: 'ExpertWeixMapPage',
  components: {
    EditMobilePhoneModal,
    ExpertUploadView,
    ExpertLeaveApplyForModal,
    DictText,
    ExpertLeaveRecord
  },
  data () {
    return {
      ExtractExpertFlagEnum,
      ExpertState,
      notices: [],
      loading: {
        reviewActiveNotice: false,
      },
      contentTypeValue: '1',
      expertInfo: {
        expertName: '专家姓名',
        extras: {
          attendRate: 0,
          singleExpertFlagNumVo: {}
        }
      },
      website: this.$ls.get(COMPANY_WEBSITE),
      consult_telePhone: this.$ls.get(CONSULT_TELE_PHONE),
      calledShowNumber: '',
      // 请假内容
      confirmLoading: false,
      leaveApplyForVisible: false,
      leaveApplyForData: { id: '', applyId: '', leaveReason: '' },
      rules: {
        leaveReason: [{ required: true, message: '请输入请假原因', trigger: 'blur' },
          { max: 500, message: '请假原因不能超过500个字', trigger: 'change' }]
      },
      // 休假内容
      leaveRecordRules: {
        leaveReason: [{ required: true, message: '请输入休假原因', trigger: 'change' }],
        leaveStartTime: [{ required: true, message: '请输入休假开始时间', trigger: 'change' }],
      },
      expertLeaveRecordList: [],
      saveLoading: false,
      seetingVisible: false,
      dateFormatStr: 'YYYY-MM-DD',
      leaveRecordType: false,
      inLeaveRecord: false,//是否正在休假
      timeStep: {
        minuteStep: 30,
        format: 'HH:mm',
        defaultValue: moment('09:00', 'HH:mm')
      },
      endTimeStep: {
        minuteStep: 30,
        format: 'HH:mm',
        defaultValue: moment('23:00', 'HH:mm')
      },
      expertLeaveForm: {
        leaveStartTime: null,
        leaveEndTime: null,
        expertId: '',
        leaveReason: '',
      },
    }
  },
  computed: {
    // 休假时间是否有效
    isEfficacious () {
      return function (leaveStartTime, leaveEndTime, state) {
        if (state === '0') {
          const now = moment()
          return ((leaveStartTime && !leaveEndTime) || (now.isSameOrBefore(leaveEndTime, 'day') && now.isSameOrAfter(leaveStartTime, 'day')) || now.isSameOrBefore(leaveStartTime, 'day'))
        }
        return false
      }
    },
    // 计算属性用于格式化日期
    formattedLeaveEndTime (leaveEndTime) {
      return function (leaveEndTime) {
        if (!leaveEndTime) {
          return '长期' // 处理空值情况
        }
        return moment(leaveEndTime).format('YYYY-MM-DD')
      }
    }
  },
  created () {
    this.loadData()
    this.onLoadReviewActiveNotice()
    this.getCalledShowNumber()
  },
  methods: {
    isLeaveRecord: IsLeaveRecord,
    async loadData () {
      let res = await GetExpertByUserId('1')
      if (res.code === 200 && res.result) {
        this.expertInfo = res.result
        await this.getExpertLeaveRecordByExpertId(res.result.id)
      }
    },
    async onLoadReviewActiveNotice () {
      const that = this
      try {
        that.loading.reviewActiveNotice = true
        const data = { pageSize: 6, expertFlag: '1' }
        let res = await QueryExpertReviewActiveNoticeListByUserIdList(data)
        that.notices = res.result
      } catch (e) {
        this.$message.error(e.message)
        that.loading.reviewActiveNotice = false
      } finally {
        that.loading.reviewActiveNotice = false
      }
    },
    async getCalledShowNumber () {
      const metadata = await QueryMetadataList('ivrCall', 'calledShowNumber')
      if (metadata.code === 200) {
        this.calledShowNumber = metadata.result[0].value
      }
    },
    // 获取休假记录
    async getExpertLeaveRecordByExpertId (expertId) {
      let res = await GetExpertLeaveRecordByExpertId(expertId, '0')
      if (res.code === 200) {
        this.expertLeaveRecordList = res.result
      }
    },
    // 切换菜单
    switchMenu (val) {
      this.contentTypeValue = val
    },
    // 评审活动请假
    showLeaveModal (record) {
      const minutes = moment(record.setOfTime).diff(moment(), 'minutes')
      if (minutes / 60 <= 2) {
        this.$warning({
          title: '温馨提示',
          content: `离集合时间不足两个小时，请拨打联系电话（${record.reviewTelephone}）进行请假，以便我们及时获悉并更换专家，谢谢配合。`,
        })
        return
      }
      this.leaveApplyForData.id = record.id
      this.leaveApplyForData.applyId = record.applyId
      this.leaveApplyForVisible = true
    },

    // 请假说明
    openLeaveDescription () {
      const content = `采购活动通知同意参加后如果有事需要请假，超过集合时间2小时的，
      可通过我司网站（${this.website || ''}）或微信公众号登录专家管理系统进行操作；若离集合时间不足2小时的，
      必须拨打咨询电话${this.consult_telePhone}进行请假。`
      this.$info({ title: '请假说明', content: content, class: 'selfModal', })
    },
    // 取消请假
    handleCancel () {
      this.leaveApplyForVisible = false
    },
    // 确认请假
    submitLeLeaveApplyFor () {
      this.$refs.form.validate(async (valid, err) => {
        if (!valid) {
          return
        }
        await this.handleLeaveApplyFor()
      })
    },
    // 提交请假
    async handleLeaveApplyFor () {
      this.confirmLoading = true
      const res = await ExpertLeaveBySelf(this.leaveApplyForData)
      if (res.code === 200) {
        this.leaveApplyForVisible = false
        this.$message.success('请假成功')
        await this.onLoadReviewActiveNotice()
      } else {
        this.$message.error(res.message)
      }
      this.confirmLoading = false
    },
    // 新增休假
    addLeaveRecord () {
      this.seetingVisible = true
      this.leaveRecordType = false
      this.expertLeaveForm = {
        leaveStartTime: null,
        leaveEndTime: null,
        expertId: '',
        leaveReason: '',
      }
    },
    // 禁用开始时间
    disabledStartDate (current) {
      const endValue = this.expertLeaveForm.leaveEndTime
      let perDay = moment(moment().format('YYYY-MM-DD'))
      let currentDay = moment(current.format('YYYY-MM-DD'))
      if (endValue) {
        let endMoment = moment(moment(endValue).format('YYYY-MM-DD'))
        return currentDay && currentDay < perDay || currentDay > endMoment
      }
      return currentDay && currentDay < perDay
    },
    // 禁用结束时间
    disabledEndDate (current) {
      const startValue = this.expertLeaveForm.leaveStartTime
      let perDay = moment(moment().format('YYYY-MM-DD'))
      let currentDay = moment(current.format('YYYY-MM-DD'))
      if (startValue) {
        let startMoment = moment(moment(startValue).format('YYYY-MM-DD'))
        return currentDay < startMoment
      }
      return currentDay && currentDay < perDay
    },
    // 休假类型选择
    onChangeLeaveRecordType (e) {
      const value = e.target.checked
      if (value) {
        this.expertLeaveForm.leaveEndTime = null
        if (!this.expertLeaveForm.leaveStartTime) {
          this.expertLeaveForm.leaveStartTime = moment().format(this.dateFormatStr)
        }
      }
    },
    onLeaveRecordSubmit () {
      const that = this
      if (ExpertState.STATE.LEAVE_DOING === this.expertInfo.state) {
        this.$warning({ title: '您已在休假期间，请进行终止休假后再新增休假' })
        return
      }
      if (!this.leaveRecordType && (!this.expertLeaveForm.leaveStartTime || !this.expertLeaveForm.leaveEndTime)) {
        this.$warning({ title: '休假开始时间和休假结束时间不能为空' })
        return
      }
      this.$refs.expertLeaveForm.validate(async (valid) => {
        if (!valid) {
          return
        }
        if (this.expertLeaveForm.leaveReason.trim() === '') {
          this.$warning({ title: '休假原因不能为空' })
          return
        }
        this.$confirm({
          title: '确定提交休假吗?',
          onOk () {
            that.handleLeaveRecordSubmit()
          },
        })
      })
    },
    // 结束休假
    onSubmitTerminationLeave (record) {
      const that = this
      this.$confirm({
        title: '确定结束休假吗?',
        onOk () {
          that.handleLeaveRecordSubmit(true, record)
        },
      })
    },
    async handleLeaveRecordSubmit (isTerminationLeave, record) {
      this.saveLoading = true
      let res
      if (isTerminationLeave) {
        res = await SetTerminationLeave(record)
      } else {
        this.expertLeaveForm.expertId = this.expertInfo.id
        res = await SetLeaveRecordTime(this.expertLeaveForm)
      }
      if (res.code === 200) {
        this.$message.success(isTerminationLeave ? '提交结束休假成功' : '提交休假成功')
      } else {
        this.$message.error(res.msg)
      }
      await this.loadData()
      this.saveLoading = false
      this.seetingVisible = false
    },
    /**
     * 修改手机号码
     */
    editPhone (expertInfoData) {
      this.$refs.editMobilePhone.expertId = expertInfoData.id
      this.$refs.editMobilePhone.editMobilePhoneModal = true
    },
  },
}
</script>

<style lang="less" scoped>
.flex_0 {
  flex: 0 0 auto;
}

.w-100 {
  width: 100%;
}

.m_zj_t3 {
  margin: 15px;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background-image: linear-gradient(to right, #d8e7f8, #edf3ff, #d1e7f7);
    border-radius: 8px;
    margin-bottom: 12px;

    .text1 {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #1f76ff;
    }

    .text2 {
      display: flex;
      align-items: center;
      line-height: 1;
      color: #1f76ff;
    }
  }
}

.wein-map-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  text-align: center;
  color: #8c8c8c;
  padding: 8px 0;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);

  i {
    font-size: 20px;
  }

  .active {
    color: #0080FF;
  }
}

.m_zj_t2 {
  margin: 15px;
  border-radius: 10px;
  overflow: hidden;

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background-image: linear-gradient(to right, #d8e7f8, #edf3ff, #d1e7f7);
    border-radius: 8px;
    margin-bottom: 12px;


    .text1 {
      display: flex;
      align-items: center;
      font-size: 15px;
      color: #EC7446;

      span {
        font-weight: bold;
        color: #000;
        font-size: 20px;
        margin: 0 4px;
        position: relative;
        top: -2px;
      }

      img {
        margin-right: 6px;
        width: 15px;
      }
    }

    .text2 {
      display: flex;
      align-items: center;
      line-height: 1;
      color: #EC7446;

      i {
        margin-right: 6px;
      }
    }
  }

  .row {
    display: flex;
    margin: 12px 0;
    font-size: 16px;
    color: #000;
    padding-right: 12px;

    .text1 {
      width: 110px;
      flex: 0 0 auto;
      padding-left: 12px;
      color: #8c8c8c;
    }
  }
}

.m_zj_t1 {
  background-image: url("../../../public/img/mobile/bg2.png");
  background-size: 100% 100%;
  height: 165px;
  margin: 15px;
  padding: 16px;

  p {
    margin: 0;
  }

  .text1 {
    color: #1150B7;
    font-size: 14px;
    margin-bottom: 4px;
  }

  .text2 {
    background: #fff;
    display: inline-block;
    color: #000;
    font-size: 15px;
    padding: 2px 8px;
    border-radius: 4px;

    &:nth-child(2) {
      margin-bottom: 20px;
    }
  }
}

.header_bg {
  position: absolute;
  background-image: url("../../../public/img/mobile/bg.png");
  height: 125px;
  width: 100%;
  background-size: 100% 100%;
  top: 0;
}

.header {
  display: flex;
  align-items: center;
  padding: 15px;
  color: #fff;
  background: rgba(255, 255, 255, 0.22);
  border-radius: 8px;
  margin: 30px 15px 0 15px;
  position: relative;
  z-index: 9;
  backdrop-filter: blur(10px);
  box-shadow: 0 5px 8px 0 rgba(0, 0, 0, 0.1);

  .right_icon {
    position: absolute;
    right: 0;
    top: 0;
    width: 90px;
  }

  .head {
    border: 2px solid #fff;
    border-radius: 4px;
    overflow: hidden;
    margin-right: 12px;
  }

  p {
    margin: 0;
  }

  .text1 {
    font-size: 17px;
    font-weight: bold;
    margin-bottom: 12px;
  }

  .text2 {
    font-size: 15px;
    display: flex;
    align-items: center;
    margin-bottom: 8px;

    a {
      background: #fff;
      color: #0963e7;
      line-height: 1;
      padding: 6px 10px;
      font-size: 12px;
      border-radius: 4px;
      margin-left: 5px;
    }
  }

  .text3 {
    padding: 3px 8px 3px 15px;
    background-image: linear-gradient(to right, #faad14, #ff4d4f);
    display: inline-flex;
    align-items: center;
    line-height: 1;
    position: relative;
    border-radius: 4px;
    margin-left: 8px;

    img {
      width: 25px;
      height: 25px;
      position: absolute;
      left: -12px;
    }
  }
}
</style>
